import { useEffect, useState } from "react";

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

// Schermata di avvio dell'app installata: video «Ai VESTA», un tocco per saltarlo
export function VestaSplash() {
  const [fase, setFase] = useState(() => (standalone() && !sessionStorage.getItem("vesta_splash") ? "on" : "off"));
  const esci = () => { setFase("out"); setTimeout(() => setFase("off"), 500); };
  useEffect(() => {
    if (fase !== "on") return undefined;
    sessionStorage.setItem("vesta_splash", "1");
    const t = setTimeout(esci, 15000);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (fase === "off") return null;
  return (
    <div role="button" tabIndex={0} onClick={esci} onKeyDown={esci} aria-label="Salta animazione"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black transition-opacity duration-500" style={{ opacity: fase === "out" ? 0 : 1 }} data-testid="vesta-splash">
      <video autoPlay muted playsInline preload="auto" onEnded={esci} className="h-full w-full object-contain" data-testid="vesta-splash-video">
        <source src="/ai-vesta-animazione.mp4" type="video/mp4" />
        <source src="/ai-vesta-animazione.webm" type="video/webm" onError={esci} />
      </video>
      <span className="pointer-events-none absolute bottom-8 left-1/2 -translate-x-1/2 text-[11px] uppercase tracking-widest text-white/40" data-testid="vesta-splash-skip">Tocca per saltare</span>
    </div>
  );
}
